import { render, staticRenderFns } from "./relation_product_form.vue?vue&type=template&id=73a54749&scoped=true"
import script from "./relation_product_form.vue?vue&type=script&lang=js"
export * from "./relation_product_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a54749",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a54749')) {
      api.createRecord('73a54749', component.options)
    } else {
      api.reload('73a54749', component.options)
    }
    module.hot.accept("./relation_product_form.vue?vue&type=template&id=73a54749&scoped=true", function () {
      api.rerender('73a54749', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/project/components/product/relation_product_form.vue"
export default component.exports